/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react"
import { Link, useParams, useSearchParams } from "react-router-dom";
import jsPDF from "jspdf";
import "jspdf-autotable";
import AppContainer from "../../Structure/AppContainer";
import Pagination from "../../Common/Pagination";
import Loader from "../../Common/Loader";
import ajaxVendor from "../../../util/remote/ajaxVendor";

const CommissionBalancesStatement=(props)=>{
    const [vendorCommissions, setVendorCommissions] = useState([]);
    const [vendorCommissionsPrintable, setVendorCommissionsPrintable] = useState([]);
    const [totalCashIn, setTotalCashIn] = useState(0);
    const [totalCashOut, setTotalCashOut] = useState(0);
    const [transactionPage, setTransactionPage] = useState(1);
    const [transactionMeta, setTransactionMeta] = useState([]);
    const [transactionLoading, setTransactionLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const {id} = useParams();
    const [searchParams] = useSearchParams();
    const username = searchParams.get('username');
    const user = searchParams.get('user');
    const startDate = searchParams.get('startDate');
    const endDate = searchParams.get('endDate');
    
    const getVendorCommissions = async (currentPage) => {
        setTransactionLoading(true);
        const server_response = await ajaxVendor.fetchVendorCommissionsReport(currentPage, id, startDate, endDate);
        setTransactionLoading(false);
        if (server_response.status === "OK") {
            setTransactionMeta(server_response.details.meta.totalPages);
            setTotalCashIn(server_response.details.total_cash_in || 0);
            setTotalCashOut(server_response.details.total_cash_out || 0);
            if (currentPage === 1) {
                setVendorCommissions(server_response.details.data || []);
            } else {
                setVendorCommissions((prevTransactions) => [
                    ...prevTransactions,
                    ...server_response.details.data,
                ]);
            }
        } else {
            setVendorCommissions([]);
        }
    };

    const getVendorCommissionsPrintable = async () => {
        setLoading(true);
        const server_response = await ajaxVendor.fetchVendorCommissionsPrintable(transactionPage,id, startDate, endDate);
        setLoading(false);
        if (server_response.status === "OK") {
            setVendorCommissionsPrintable(server_response.details.data || []);

        } else {
          setVendorCommissionsPrintable([]);
        }
    };

    const handlePagination = (newPage) => {
        if (newPage > 0 && newPage <= transactionMeta) {
          setTransactionPage(newPage);
        }
    };

    const exportToPDF = () => {
        const pdf = new jsPDF("p", "pt", "a4");

        const heading = "BUZZTIME VENDOR COMMISSION STATEMENT";
        const pageWidth = pdf.internal.pageSize.getWidth();
        const textWidth = pdf.getTextWidth(heading);
        const xPosition = (pageWidth - textWidth) / 2; // Calculate center position
        pdf.text(heading, xPosition, 30); // Add text at the top
      
        // Columns and data for the transaction table
        const columns = ["Invoice Date", "Transaction ID", "Description", "In", "Out"];
        const data = vendorCommissionsPrintable.map(item => [
          item.created_at?.when,
          item.transaction_number,
          item.description,
          item.type === "Deposit" ? item.amount : "0",
          item.type === "Withdraw" ? item.amount : "0"
        ]);
      
        // Combine student info into a single row
        const studentInfo = [
          ["Names: " + user, "Username: " + username, "Total Cash In: " + (totalCashIn ? totalCashIn.total_c : "0") + " | Total Cash Out: " + (totalCashOut ? totalCashOut.total_c : "0")]
        ];

        if (startDate || endDate) {
            studentInfo.push([
                startDate ? `Start Date: ${startDate}` : "",
                endDate ? `End Date: ${endDate}` : "",
                ""
            ]);
        }
      
        // First, add a row for the title with 2 rows of headers
        let yPosition = 20;  // Starting Y position
        
        pdf.autoTable({ // Title row, spanning across all columns
          body: [["", "", "", ""]], // Empty body row for spacing
          startY: yPosition,
          theme: 'plain',
          margin: { top: 5 },
          styles: { halign: "center", fontSize: 14, fontStyle: "bold" }, // Customize styles for title row
        });
      
        // Add the student info row (with colSpan)
        pdf.autoTable({
          head: [["", "", ""]], // Empty row to align with student info
          body: studentInfo, // Combined row with labels and data in the same cells
          startY: yPosition + 20,  // Adjust to position below the title row
          theme: 'plain',
          margin: { top: 5 },
          styles: { fontSize: 10 },
        });
      
        // Now add the actual transaction table
        pdf.autoTable({
          head: [columns], // Column headers for the transaction table
          body: data,  // Data for the table
          startY: yPosition + 100,  // Start the table below the student info
        });
        
        // Save the PDF
        pdf.save("buzztime_vendor_commissionstatement.pdf");
      };

    

    useEffect(() => {
          getVendorCommissions(transactionPage, id, startDate, endDate);
      }, [transactionPage, id, startDate, endDate]);

    useEffect(() => {
          getVendorCommissionsPrintable(id, startDate, endDate);
      }, [id, startDate, endDate]);


    return(
        <AppContainer title={"Vendor Commission Statement"} >
            
            <div className="row">
                <div className="col-lg-12">
                <div className="card custom-card">
                    <div className="card-body map-card">
                    <div class="heading-layout1 mg-b-25">
                        
                        <div class="dropdown">
                        <Link class="" onClick={exportToPDF} role="button"><i class="fas fa-download ml-3"></i></Link>
                        </div>
                    </div>


                    <div className="border-top mt-3"></div>
                    <div className="table-responsive">
                        {transactionLoading || loading ? (
                            <Loader />
                        ) : (
                                <table className="table display data-table text-nowrap">
                                    <thead>
                                        <tr>
                                            <th scope="col" colSpan="5" style={{ textAlign: "center" }}>VENDOR COMMISSION STATEMENT </th>
                                        </tr>
                                        <tr>
                                            <th scope="col" colSpan="2">Names :  {user}</th>
                                            <th scope="col" colSpan="1">Username : {username}</th>

                                        </tr>
                                    
                                        <tr>
                                            <th scope="col">Invoice Date</th>
                                            <th scope="col">Transaction ID</th>
                                            <th scope="col">Description</th>
                                            <th scope="col"> In</th>
                                            <th scope="col"> Out</th>
                                        
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {vendorCommissions.length > 0 ? (
                                            vendorCommissions.map((item, index) => (
                                            <tr key={index}>
                                                

                                                <td>{item.created_at?.when} </td>
                                                
                                                <td>{item.transaction_number}</td>
                                                <td>{item.description}</td>

                                                <td>{item.type === "Deposit" ? item.amount : "0"}</td>
                                                <td>{item.type === "Withdraw"? item.amount : "0"}</td>

                                            </tr>
                                            
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="5" style={{ textAlign: "center" }}>
                                                    No commissions yet.
                                                </td>
                                            </tr>
                                        )}
                                        <tr>
                                                <td colSpan="3"></td>
                                                <td><strong>Total In: </strong> {totalCashIn?totalCashIn.total_c:"0"}</td>
                                                <td><strong>Total Out: </strong> {totalCashOut?totalCashOut.total_c:"0"}</td>   
                                            </tr>
                                    </tbody>
                                </table>
                        )}
                    </div>
                    <Pagination currentPage={transactionPage} totalPages={transactionMeta} onPageChange={handlePagination}/>
                    </div>
                </div>
                </div>
            </div> 
     

      
          

        </AppContainer>
        
    )
}

export default CommissionBalancesStatement
